import { Grid, Typography } from '@mui/material';

import useSettings from 'app/main/components/hooks/useSettings';
import EditorHtmlField, { type EditorHtmlFieldProps } from 'app/main/components/fields/EditorHtmlField';

import ActivitiesFastAddDialogSettings from 'app/main/modules/activities/ActivitiesFastAddDialogSettings';
import ChronologyFastAddDialogSettings from 'app/main/modules/chronology/ChronologyFastAddDialogSettings';
import CommercialCampaignsFastAddDialogSettings from 'app/main/modules/commercialcampaigns/CommercialCampaignsFastAddDialogSettings';
import CompaniesFastAddDialogSettings from 'app/main/modules/companies/CompaniesFastAddDialogSettings';
import ContractsFastAddDialogSettings from 'app/main/modules/contracts/ContractsFastAddDialogSettings';
import DemsFastAddDialogSettings from 'app/main/modules/dems/DemsFastAddDialogSettings';
import GroupsFastAddDialogSettings from 'app/main/modules/groups/GroupsFastAddDialogSettings';
import ItemsFastAddDialogSettings from 'app/main/modules/items/ItemsFastAddDialogSettings';
import MarketingActionsFastAddDialogSettings from 'app/main/modules/marketingactions/MarketingActionsFastAddDialogSettings';
import OpportunitiesFastAddDialogSettings from 'app/main/modules/opportunities/OpportunitiesFastAddDialogSettings';
import OrdersFastAddDialogSettings from 'app/main/modules/orders/OrdersFastAddDialogSettings';
import PeopleFastAddDialogSettings from 'app/main/modules/people/PeopleFastAddDialogSettings';
import ProjectsFastAddDialogSettings from 'app/main/modules/projects/ProjectsFastAddDialogSettings';
import TicketsFastAddDialogSettings from 'app/main/modules/tickets/TicketsFastAddDialogSettings';
import UsersFastAddDialogSettings from 'app/main/modules/users/UsersFastAddDialogSettings';
import WorkReportsFastAddDialogSettings from 'app/main/modules/workreports/WorkReportsFastAddDialogSettings';

import InvoicesFastAddDialogSettings from 'app/main/submodules/invoices/InvoicesFastAddDialogSettings';
import MailsFastAddDialogSettings from 'app/main/submodules/mails/MailsFastAddDialogSettings';
import PhonesFastAddDialogSettings from 'app/main/submodules/phones/PhonesFastAddDialogSettings';
import SocialNetworksFastAddDialogSettings from 'app/main/submodules/socialnetworks/SocialNetworksFastAddDialogSettings';
import WebsitesFastAddDialogSettings from 'app/main/submodules/websites/WebsitesFastAddDialogSettings';

export function InlineTitle({ text }: { text: string }) {
	const { t } = useSettings();

	return (
		<Grid size={12}>
			<Typography className="p-4" variant="subtitle2">
				{t(text)}
			</Typography>
		</Grid>
	);
}

export function DescriptionSection(props: Pick<EditorHtmlFieldProps, 'name' | 'value' | 'isEdit' | 'sendChange'>) {
	return (
		<Grid size={12}>
			<EditorHtmlField {...props} />
		</Grid>
	);
}

const fastAddDialogs = {
	activities: ActivitiesFastAddDialogSettings,
	chronology: ChronologyFastAddDialogSettings,
	commercialcampaigns: CommercialCampaignsFastAddDialogSettings,
	companies: CompaniesFastAddDialogSettings,
	contracts: ContractsFastAddDialogSettings,
	dems: DemsFastAddDialogSettings,
	groups: GroupsFastAddDialogSettings,
	invoices: InvoicesFastAddDialogSettings,
	items: ItemsFastAddDialogSettings,
	mails: MailsFastAddDialogSettings,
	marketingactions: MarketingActionsFastAddDialogSettings,
	opportunities: OpportunitiesFastAddDialogSettings,
	orders: OrdersFastAddDialogSettings,
	people: PeopleFastAddDialogSettings,
	phones: PhonesFastAddDialogSettings,
	projects: ProjectsFastAddDialogSettings,
	socialnetworks: SocialNetworksFastAddDialogSettings,
	tickets: TicketsFastAddDialogSettings,
	users: UsersFastAddDialogSettings,
	websites: WebsitesFastAddDialogSettings,
	workreports: WorkReportsFastAddDialogSettings
};

export default fastAddDialogs;
